interface KPICardProps {
  icon: string;
  label: string;
  value: string | number;
  trend?: number;
  trendLabel?: string;
  loading?: boolean;
}

export function KPICard({ icon, label, value, trend, trendLabel, loading }: KPICardProps) {
  if (loading) {
    return (
      <div class="bg-white rounded-xl border border-gray-200 p-5 animate-pulse">
        <div class="h-4 bg-gray-200 rounded w-24 mb-3" />
        <div class="h-8 bg-gray-200 rounded w-16 mb-2" />
        <div class="h-3 bg-gray-200 rounded w-20" />
      </div>
    );
  }

  const trendColor = trend && trend > 0 ? 'text-green-600' : trend && trend < 0 ? 'text-red-600' : 'text-gray-500';
  const trendArrow = trend && trend > 0 ? '↑' : trend && trend < 0 ? '↓' : '';

  return (
    <div class="bg-white rounded-xl border border-gray-200 p-5 hover:shadow-md transition-shadow">
      <div class="flex items-center gap-2 text-gray-500 text-sm mb-1">
        <span>{icon}</span>
        <span>{label}</span>
      </div>
      <div class="text-2xl font-bold text-gray-900 mb-1">{typeof value === 'number' ? value.toLocaleString() : value}</div>
      {trend !== undefined && (
        <div class={`text-xs ${trendColor} font-medium`}>
          {trendArrow} {Math.abs(trend)}% {trendLabel || 'vs período anterior'}
        </div>
      )}
    </div>
  );
}
